













































import { Component, Vue, Watch } from 'vue-property-decorator';
import VSpacer from '@/components/commons/VSpacer.vue'; // @ is an alias to /src
import '@/utils/filter';
import { default as axios } from 'axios';
import { Utils } from '@/utils/utils';
import { ToDoInterface, ToDoState } from '@/interfaces/todo/todo.interface';

@Component({
  components: {
    VSpacer,
  },
})
export default class TasksList extends Vue {
  public categoriesItems: string[] = ['Terminées', 'En cours', 'A faire'];
  public categoriesValues: string[] = ['Terminées', 'En cours', 'A faire'];

  get tasksToDisplay(): ToDoInterface[] {
    return this.$store.state.tasksToDisplay;
  }
  get tasks(): ToDoInterface[] {
    return this.$store.state.tasks;
  }

  constructor() {
    super();
    axios
      .get(`${process.env.VUE_APP_API_URL}/todos/all`)
      .then(response => {
        const result: ToDoInterface[] = response.data as ToDoInterface[];
        this.$store.dispatch('setTasksToDisplay', result);
        this.$store.dispatch('setTasks', result);
      })
      .catch(err => {
        console.error(err);
      });
  }

  @Watch('categoriesValues')
  onPropertyChanged(value: string[], oldValue: string[]) {
    if (value instanceof Array) {
      const tmp: ToDoInterface[] = new Array();
      value.forEach(s => {
        this.tasks.forEach(t => {
          if (Utils.translateTodoStateVerbose(s) === t.state) {
            tmp.push(t);
          }
        });
      });
      this.$store.dispatch('setTasksToDisplay', tmp);
    }
  }

  axiosUpdateState(title: string, state: string) {
    axios
      .patch(`${process.env.VUE_APP_API_URL}/todos/${title}`, { state })
      .then(response => {
        (this.tasksToDisplay.find(
          elt => elt.title === title,
        ) as ToDoInterface).state = Utils.translateTodoState(state);
      })
      .catch(err => {
        console.error(err);
      });
  }

  beginTask(title: string) {
    this.axiosUpdateState(title, 'WIP');
  }

  endTask(title: string) {
    this.axiosUpdateState(title, 'DONE');
  }
}
